import { addBreadcrumb } from '@mentimeter/errors/sentry';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';

export const handleNoInteractiveContentError = (
  target: VotingSlide | CompatibilitySlide,
  prop: string,
) => {
  addBreadcrumb({
    message: 'InteractiveContent not found for slide',
    data: {
      slidePublicKey: target.slidePublicKey,
      prop,
      staticContentType: target.staticContent?.type,
    },
  });

  return undefined;
};
